import {
  StyledHeroScroll,
  StyledHeroScrollMouse,
  StyledHeroScrollMouseBall,
  StyledHeroScrollText
} from 'components/jobOffer/hero/HeroScroll.styled';

const LaunchHeroScroll: React.FC = () => {
  return (
    <StyledHeroScroll href="#manifest">
      <StyledHeroScrollMouse>
        <StyledHeroScrollMouseBall />
      </StyledHeroScrollMouse>
      <StyledHeroScrollText>
        <span>Haz scroll</span>
        <strong>y te contamos más</strong>
      </StyledHeroScrollText>
    </StyledHeroScroll>
  );
};

export default LaunchHeroScroll;
